import styles from './opportunityjourneywrapper.module.css';
import { OpportunityJourneySquare } from './OpportunityJourneySquare';
import OpportunityDetails from './OpportunityDetails';
import ReminderComponent from '../ReminderComponent'
import InteractionComponent from '../InteractionComponent'

const OpportunityJourneyContainerWrapper = ({oppData}) => {
    return(
        <div className={styles.wrapper}>
            <OpportunityJourneySquare  oppData = {oppData}/>
            <OpportunityDetails oppData = {oppData}/>
            <div className='flex justify-between w-full mr-5'>
                <ReminderComponent />
                <InteractionComponent />
            </div>
        </div>
    )
}
export default OpportunityJourneyContainerWrapper;